export default __webpack_public_path__ + "static/consulting-1-96dc80eef8030dbb0f2427b5a7cf550b.png";